import {
  UPDATE_THANK_YOU_PAGE_SETTING,
  GET_THANK_YOU_PAGE_SETTING,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const bookReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THANK_YOU_PAGE_SETTING:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_THANK_YOU_PAGE_SETTING:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default bookReducer;
